import React, { useState } from 'react';
import { Row, Col, Card, CardBody, CardTitle, Button, Alert } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import BulkUploadModal from '../../components/Modals/BulkUploadModal';
import ProgressReport from '../../components/Common/ProgressReport';

const CargaParametrosPage = () => {
  document.title = "Carga de Parámetros | GraphicForce - Printesco";

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);

  const handleOpenModal = () => {
    setUploadResult(null); // Clear previous results
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleUploadComplete = (result) => {
    setUploadResult(result);
    setIsModalOpen(false);
  };

  const handleUploadError = (result) => {
    setUploadResult(result);
    setIsModalOpen(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs 
            maintitle="Dashboard" 
            title="Administración" 
            breadcrumbItem="Carga de Parámetros" 
          />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <CardTitle className="h4 d-flex justify-content-between align-items-center">
                    Carga Masiva de Parámetros
                    <Button 
                      color="primary" 
                      size="sm" 
                      onClick={handleOpenModal}
                    >
                      <i className="fas fa-upload me-1"></i> Cargar Archivo CSV
                    </Button>
                  </CardTitle>
                  
                  <div className="mt-4">
                    <h5>Instrucciones:</h5>
                    <ol>
                      <li>Seleccione la tabla a cargar (actualmente solo disponible: Cliente)</li>
                      <li>Prepare su archivo CSV con los datos siguiendo el formato correcto</li>
                      <li>Haga clic en "Cargar Archivo CSV" para iniciar el proceso</li>
                      <li>Revise los resultados del procesamiento</li>
                    </ol>
                  </div>

                  <div className="mt-4">
                    <h6>Formato del archivo CSV para Clientes:</h6>
                    <p>El archivo debe contener las siguientes columnas (solo razon_social es obligatorio):</p>
                    <ul>
                      <li><strong>razon_social</strong> (obligatorio): Nombre de la empresa</li>
                      <li><strong>nit</strong> (opcional): Número de identificación tributaria</li>
                      <li><strong>telefono</strong> (opcional): Teléfono fijo (10 dígitos)</li>
                      <li><strong>celular</strong> (opcional): Número de celular (10 dígitos)</li>
                      <li><strong>activo</strong> (opcional): true/false, 1/0, yes/no, sí/no</li>
                    </ul>
                  </div>

                  {uploadResult && (
                    <div className="mt-4">
                      <ProgressReport result={uploadResult} />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <BulkUploadModal
        isOpen={isModalOpen}
        toggle={handleCloseModal}
        onUploadComplete={handleUploadComplete}
        onError={handleUploadError}
      />
    </React.Fragment>
  );
};

export default CargaParametrosPage;
